var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Edit Company Info",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1100px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "autocomplete": "off",
      "label-position": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "lg": 18,
      "xl": 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name (Option 1)",
      "prop": "proposedCompanyName1"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    staticClass: "input-with-select-lg",
    attrs: {
      "placeholder": "Proposed Company Name (Option 1)"
    },
    model: {
      value: _vm.dataForm.proposedCompanyName1,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "proposedCompanyName1", $$v);
      },
      expression: "dataForm.proposedCompanyName1"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "append"
    },
    slot: "append",
    model: {
      value: _vm.dataForm.proposedCompanyType1,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "proposedCompanyType1", $$v);
      },
      expression: "dataForm.proposedCompanyType1"
    }
  }, _vm._l(_vm.companySuffixList, function (item) {
    return _c('el-option', {
      key: "suffix01-".concat(item),
      attrs: {
        "label": item,
        "value": item
      }
    });
  }), 1)], 1)], 1)], 1)], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "lg": 18,
      "xl": 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name (Option 2)",
      "prop": "proposedCompanyName2"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    staticClass: "input-with-select-lg",
    attrs: {
      "placeholder": "Proposed Company Name (Option 2)"
    },
    model: {
      value: _vm.dataForm.proposedCompanyName2,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "proposedCompanyName2", $$v);
      },
      expression: "dataForm.proposedCompanyName2"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "append"
    },
    slot: "append",
    model: {
      value: _vm.dataForm.proposedCompanyType2,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "proposedCompanyType2", $$v);
      },
      expression: "dataForm.proposedCompanyType2"
    }
  }, _vm._l(_vm.companySuffixList, function (item) {
    return _c('el-option', {
      key: "suffix02-".concat(item),
      attrs: {
        "label": item,
        "value": item
      }
    });
  }), 1)], 1)], 1)], 1)], 1), _c('el-row', [_c('el-col', {
    attrs: {
      "lg": 18,
      "xl": 15
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Company Name (Option 3)",
      "prop": "proposedCompanyName3"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    staticClass: "input-with-select-lg",
    attrs: {
      "placeholder": "Proposed Company Name (Option 3)"
    },
    model: {
      value: _vm.dataForm.proposedCompanyName3,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "proposedCompanyName3", $$v);
      },
      expression: "dataForm.proposedCompanyName3"
    }
  }, [_c('el-select', {
    attrs: {
      "slot": "append"
    },
    slot: "append",
    model: {
      value: _vm.dataForm.proposedCompanyType3,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "proposedCompanyType3", $$v);
      },
      expression: "dataForm.proposedCompanyType3"
    }
  }, _vm._l(_vm.companySuffixList, function (item) {
    return _c('el-option', {
      key: "suffix03-".concat(item),
      attrs: {
        "label": item,
        "value": item
      }
    });
  }), 1)], 1)], 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "MSIC Code(Maximum 3)",
      "prop": "msicCodes"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "multiple": "",
      "multiple-limit": 3,
      "filterable": "",
      "placeholder": "Select",
      "popper-class": "tradeWrap"
    },
    model: {
      value: _vm.dataForm.msicCodes,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "msicCodes", $$v);
      },
      expression: "dataForm.msicCodes"
    }
  }, _vm._l(_vm.msicOptions, function (item, i) {
    return _c('el-option', {
      key: 'msic-' + i,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    });
  }), 1)], 1)], 1), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Business Description",
      "prop": "businessDescription"
    }
  }, [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    staticClass: "wdb100",
    attrs: {
      "type": "textarea",
      "placeholder": "Please enter",
      "rows": 5,
      "autosize": {
        minRows: 4
      },
      "maxlength": "78",
      "show-word-limit": "",
      "resize": "none"
    },
    model: {
      value: _vm.dataForm.businessDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "businessDescription", $$v);
      },
      expression: "dataForm.businessDescription"
    }
  })], 1)], 1), _vm.isNeedNomineeDirector ? _c('el-form-item', {
    attrs: {
      "label": "Nominee Director Service",
      "prop": "hasNomineeDirector"
    }
  }, [_c('el-checkbox', {
    staticClass: "checkboxCustom",
    attrs: {
      "true-label": 1,
      "false-label": 0
    },
    model: {
      value: _vm.dataForm.hasNomineeDirector,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "hasNomineeDirector", $$v);
      },
      expression: "dataForm.hasNomineeDirector"
    }
  }, [_vm._v(" We consent to appoint one Nominee Director recommended by EStar Business Sdn. Bhd. (\"EStar\"), and we understand that any legal impact caused by the Nominee Director's action has nothing to do with EStar. ")])], 1) : _vm._e()], 1), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.dataFormSubmit();
      }
    }
  }, [_vm._v("OK")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }